import { User } from '../user/user';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export class Comment
{
    id: number ; 
    content: string; 
    user: User; 
    ticket: number; 
    postedon: Date;
disabled: boolean;
    config :ClassicEditor.config;
}
